// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
import Vant from 'vant';
import 'vant/lib/vant-css/index.css';
import 'lib-flexible'
import Vuex from 'vuex'
import store from './vuex/store'
import Navigation from 'vue-navigation'
// import "../src/api/axios.js" 
import axios from 'axios'
import wx from "weixin-js-sdk"
// import wx from 'weixin-js-sdk'
// import wx from 'weixin-js-sdk'


Vue.prototype.$axios = axios

Vue.config.productionTip = false
Vue.use(MintUI)
Vue.use(Vant);
Vue.use(Vuex)
Vue.use(Navigation, {router,store})
Vue.prototype.$wx = wx;
// Vue.prototype.wx = wx
Vue.config.ignoredElements = ['wx-open-launch-weapp']

// 监测是否有网
var el = document.body;
if (el.addEventListener) {
  window.addEventListener("online", function () {
  }, true);
  window.addEventListener("offline", function () {
    router.push('/offLine')
  }, true);
}
else if (el.attachEvent) {
  window.attachEvent("ononline", function () {
  });
  window.attachEvent("onoffline", function () {
    router.push('/offLine');
  });
}
else {
  window.ononline = function () {
    window.onlineStatus = true;
  };
  window.onoffline = function () {
    router.push('/offLine');
  };
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js